module.exports = __webpack_public_path__ + "static/media/project.25da9a9f.png";